var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.story
    ? _c(
        "a",
        {
          staticClass: "story-block",
          staticStyle: { width: "100%" },
          attrs: { href: _vm.getUrl(_vm.story) }
        },
        [
          _c("div", { staticClass: "story-block-image" }, [
            _c("img", { attrs: { src: _vm.getImage(_vm.story) } })
          ]),
          _vm._v(" "),
          _vm.icon ? _c("div", { staticClass: "story-block-icon" }) : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "story-block-body" }, [
            _c("div", { staticClass: "story-block-body-inner" }, [
              _c("h4", [
                _c("span", { staticClass: "story-number" }, [
                  _vm._v("STORY " + _vm._s(_vm.randomNumber))
                ]),
                _c("span", { staticClass: "story-date" }, [
                  _vm._v(
                    "posted " +
                      _vm._s(
                        _vm.printDate(
                          _vm.story.posted,
                          "yyyy-MM-dd HH:mm:ss",
                          "M.d.yy"
                        )
                      )
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "h3",
                {
                  directives: [
                    {
                      name: "balance-text",
                      rawName: "v-balance-text.children",
                      modifiers: { children: true }
                    }
                  ],
                  staticStyle: { "text-wrap": "balance" }
                },
                [
                  _c("div", {
                    domProps: { innerHTML: _vm._s(_vm.story.title) }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "attribution" }, [
                _c("i", { staticClass: "fas fa-blog" }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "BY " +
                      _vm._s(_vm.story.first_name) +
                      " " +
                      _vm._s(_vm.story.last_name)
                  )
                ])
              ])
            ])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-svg-inline-loader/dist/index.min.js?{}!./scripts/components/StoryBlock.vue?vue&type=template&id=76e6ecb6&
// module id = 440
// module chunks = 0